const COLOR_CATALOG_REFRESH_INTERVAL_MS = 30_000

/** Per-app navigation refreshes; no polling and no shared SSR state. */
export function createColorCatalogRefresh(refresh: () => Promise<unknown>) {
  const lastAttempt = new Map<string, number>()
  const pending = new Map<string, Promise<unknown>>()

  return (key: string, hasCatalog: boolean): Promise<unknown> | undefined => {
    const inFlight = pending.get(key)
    if (inFlight)
      return hasCatalog ? undefined : inFlight

    const now = Date.now()
    if (hasCatalog && now - (lastAttempt.get(key) ?? -Infinity) < COLOR_CATALOG_REFRESH_INTERVAL_MS)
      return

    lastAttempt.set(key, now)
    const request = refresh().finally(() => pending.delete(key))
    pending.set(key, request)

    // A missing market catalog must be ready before constructing page filters.
    if (!hasCatalog)
      return request

    // Existing colors remain usable even if background revalidation fails.
    void request.catch(() => {})
  }
}
